import React from 'react';
import { TaskState } from 'gql/graphql';
import { TaskStateIcon } from './SharedComponents';
import { ModuleKeys } from 'services/task/modules-keys.constanst';

interface BorrowerItemProps {
  item: any;
  tasks: any[];
  handlerSetTaskOpenModal: (key: string) => void;
}

export const BorrowerTaskItem: React.FC<BorrowerItemProps> = ({
  item,
  tasks,
  handlerSetTaskOpenModal
}) => {
  const getTitleCompanyTask = () =>
    tasks.find((item) => item.key === ModuleKeys.TITLE_COMPANY);

  const openTitleCompanyTask = () => {
    if (getTitleCompanyTask()?.state === TaskState.Draft || getTitleCompanyTask()?.state === TaskState.RequestError) return true;
    return getTitleCompanyTask()?.metadata?.titleCompany ?? false;
  }

  // Determinar el cursor para borrower task items
  const getItemCursor = () => {
    if (item.state === 'BLOCKED') return 'pointer';
    if (item.key === 'initial_app') return 'default';
    if (item.key === ModuleKeys.PAY_APPRAISAL && (item.state === TaskState.Approved || item.state === TaskState.Review)) return 'default';
    if (item.key === ModuleKeys.TITLE_COMPANY) return openTitleCompanyTask() ? 'pointer' : 'default';
    return item.state !== TaskState.ComingSoon ? 'pointer' : 'default';
  };

  const handleItemClick = () => {
    if (item.state === TaskState.ComingSoon) return;

    if (item.key === ModuleKeys.TITLE_COMPANY) {
      if (openTitleCompanyTask()) handlerSetTaskOpenModal(ModuleKeys.TITLE_COMPANY);
      return;
    }

    if (item.key === ModuleKeys.PAY_APPRAISAL) {
      if (item.state === TaskState.Draft || item.state === TaskState.RequestError) {
        handlerSetTaskOpenModal(ModuleKeys.PAY_APPRAISAL);
      }
    } 
    else handlerSetTaskOpenModal(item.key);
  };

  const renderActionLabel = () => {
    if ((item.state === 'BLOCKED' || item.state === TaskState.Incomplete || item.state === TaskState.Draft) && !item.loanDoc) {
      return <b> | Complete Task<strong>{'->'}</strong></b>;
    }
    
    const isViewTaskState =
      item.state === TaskState.Approved ||
      item.state === TaskState.Review ||
      item.state === TaskState.RequestError;
    const allowedForViewTask =
      item.key !== 'initial_app' &&
      (item.key !== ModuleKeys.PAY_APPRAISAL || item.state === TaskState.RequestError) &&
      (item.key !== ModuleKeys.TITLE_COMPANY || item.state === TaskState.RequestError || openTitleCompanyTask());

    if (isViewTaskState && allowedForViewTask) {
      return <b> | View Task <strong>{'->'}</strong></b>;
    }
    
    return null;
  };

  return (
    <div
      className={`task-item task-item-${item.state}`}
      style={{ cursor: getItemCursor() }}
      onClick={handleItemClick}
    >
      <TaskStateIcon state={item.state} />
      <span className="task-label">
        {item.text}
        {renderActionLabel()}
      </span>
    </div>
  );
};